import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { BaseComponent } from 'src/app/shared/components/base-component/base.component';
import { ActivatedRoute } from '@angular/router';
import { TreatmentCenterService } from '../../treatment-center.service';
import { StatisticsPlot, StatisticsTable } from '@shared/modules/statistics/statistics.model';
import { WsHelperService } from '@shared/services/ws-helper.service';
import { PageWithSidebarComponent } from '@shared/modules/details-commons/components/page-with-sidebar/page-with-sidebar.component';
import { TreatmentCenterDetailsComponent } from '../treatment-center-details/treatment-center-details.component';

import { StatisticsComponent } from '@shared/modules/statistics/components/statistics/statistics.component';

@Component({
  templateUrl: './treatment-center-details-page.component.html',
  imports: [PageWithSidebarComponent, TreatmentCenterDetailsComponent, StatisticsComponent]
})
export class TreatmentCenterDetailsPageComponent extends BaseComponent {
  private readonly treatmentCenterService = inject(TreatmentCenterService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly wsHelperService = inject(WsHelperService);

  private _treatmentCenterId: number;

  statisticsTable: StatisticsTable;
  statisticsPlots: StatisticsPlot;

  constructor() {
    const route = inject(ActivatedRoute);

    super();
    this.subSink.sink = route.params.subscribe(params => (this.treatmentCenterId = params.id));
  }

  get treatmentCenterId(): number {
    return this._treatmentCenterId;
  }

  set treatmentCenterId(id: number) {
    if (this._treatmentCenterId !== id) {
      this._treatmentCenterId = id;
      this.loadStatistics(id);
      this.loadStatisticsPlots(id);
    }
  }

  loadStatistics(partnerId: number): void {
    this.wsHelperService.callWithSpinner(this.treatmentCenterService.getTCStatistics(partnerId)).subscribe(stats => {
      this.statisticsTable = stats;
      this.changeDetectorRef.markForCheck();
    });
  }

  loadStatisticsPlots(partnerId: number): void {
    this.wsHelperService.callWithSpinner(this.treatmentCenterService.getTCStatisticsPlot(partnerId)).subscribe(statisticsPlots => {
      this.statisticsPlots = statisticsPlots;
      this.changeDetectorRef.markForCheck();
    });
  }
}
